import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Card as MUICard,
  CardContent,
  CardActions,
  CardHeader,
  Typography,
  Button,
  Grid,
} from '@mui/material';
const PREFIX = 'Card';

const classes = {
  card: `${PREFIX}-card`,
  cardActions: `${PREFIX}-cardActions`,
  cardActionsError: `${PREFIX}-cardActionsError`,
  cardError: `${PREFIX}-cardError`
};

const StyledMUICard = styled(MUICard)((
  {
    theme
  }
) => ({
  [`&.${classes.card}`]: {
    'marginTop': theme.spacing(2),
    '&:first-of-type': {
      marginTop: theme.spacing(0),
    },
    'flexGrow': 1,
    '& .MuiCardHeader-root': {
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.divider,
    },
  },

  [`& .${classes.cardActions}`]: {
    borderTop: '1px solid',
    borderTopColor: theme.palette.divider,
  },

  [`& .${classes.cardActionsError}`]: {
    borderTop: '1px solid',
    borderTopColor: theme.palette.error.light,
  },

  [`&.${classes.cardError}`]: {
    'border': '1px solid',
    'borderColor': theme.palette.error.light,
    '& .MuiCardHeader-root': {
      color: theme.palette.error.main,
      borderBottom: '1px solid',
      borderBottomColor: theme.palette.error.light,
    },
  }
}));

export default function Card(props) {


  const errorHeaderMsg = function(){
    if(props.error) {
      return (
        <Typography variant="caption" component="p">
          {props.error}
        </Typography>
      );
    }
  };

  return (
    <StyledMUICard
      className={clsx(classes.card, {
        [classes.cardError]: Boolean(props.error),
      })}
      variant="outlined"
      name={props.name}
    >
      <CardHeader
        title={
          <Typography variant="subtitle2" component={props.titleComponent}>
            {props.title}
          </Typography>
        }
        subheader={errorHeaderMsg()}
      />
      {props.content && (
        <CardContent>
          <Grid container>
            <Grid item xs={12}>
              {props.content}
            </Grid>
          </Grid>
        </CardContent>
      )}
      {!props.readOnly &&
      (props.primaryButton || props.secondaryButton) && 
        <CardActions
          className={clsx({
            [classes.cardActions]: Boolean(props.error) === false,
            [classes.cardActionsError]: Boolean(props.error) === true,
          })}
        >
          <Button color="primary" onClick={props.primaryClick} name={`${props.name}-primary-btn`}>
            {props.primaryButton}
          </Button>
          {props.secondaryButton && props.secondaryClick &&
            <Button color="primary" onClick={props.secondaryClick} name={`${props.name}-secondary-btn`}>
              {props.secondaryButton}
            </Button>
          }
        </CardActions>
      }
      {props.readOnly && props.isOutput &&
        <CardActions
          className={clsx({
            [classes.cardActions]: Boolean(props.error) === false,
            [classes.cardActionsError]: Boolean(props.error) === true,
          })}
        >
          <Button color="primary" onClick={props.primaryClick} name={`${props.name}-primary-btn`}>
            {props.primaryButton}
          </Button>
        </CardActions>
      }
    </StyledMUICard>
  );
}

Card.propTypes = {
  /*
    The title of the card header.
  */
  title: PropTypes.string.isRequired,
  /**
    The component used for the root node of the card title.
   */
  titleComponent: PropTypes.elementType,
  /*
    Error message related to the card.
  */
  error: PropTypes.string,
  /*
  The content of the card body.
  */
  content: PropTypes.element,
  /*
    The label text of the primary button.
  */
  primaryButton: PropTypes.string.isRequired,
  /*
    The label text of the secondary button.
  */
  secondaryButton: PropTypes.string,
  /*
  The function of the primary button.
  */
  primaryClick: PropTypes.func,
  /*
  The function of the secondary button.
  */
  secondaryClick: PropTypes.func,
  /*
  Bool to determine if the actions should be displayed 
  */
  readOnly: PropTypes.bool.isRequired,
  /*
  Bool to determine if the card is to display an output
  */
  isOutput: PropTypes.bool.isRequired,
  /*
  Name of the card
  */
  name: PropTypes.string.isRequired,
};
Card.defaultProps = {
  titleComponent: 'h3'
};